<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormProductoPresentacion" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                            <label for="">Material</label>
                            <input disabled type="text" class="form-control" placeholder="Agregar Material" v-model="objProductoPresentacion.NombreMaterial">
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                            <label for="">Unidad</label>
                            <input disabled type="text" class="form-control" placeholder="Agregar Unidad" v-model="objProductoPresentacion.Nombre">
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                            <label for="">Sub Unidad</label>
                            <input disabled type="text" class="form-control" placeholder="Agregar Sub Unidad" v-model="objProductoPresentacion.SubUnidadCompleta">
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                            <label for="">Precio del Material</label>
                            <input disabled type="text" class="form-control" placeholder="Agregar Precio del Material" v-model="objProductoPresentacion.Costo">
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                            <label for="">Cantidad ({{ objProductoPresentacion.SubUnidad }})</label>
                            <input type="text" class="form-control" placeholder="Agregar Cantidad" v-model="objProductoPresentacion.CantidadProductos" @input="$number_decimal($event,objProductoPresentacion,'CantidadProductos');Calcular(objProductoPresentacion);">
                            <CValidation v-if="this.errorvalidacion.Cantidad" :Mensaje="'*'+errorvalidacion.Cantidad[0]"/>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                            <label for="">Precio Total</label>
                            <input disabled type="text" class="form-control" placeholder="Agregar Precio Total" v-model="objProductoPresentacion.PrecioTotal">
                        </div>
                    </div>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>

export default {
    props:['poBtnSave'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objProductoPresentacion:{
                IdProductoPresentacion:0,
                Material:'',
                Unidad:'',
                SubUnidad:'',
                Precio:0,
                Cantidad:0,
                PrecioTotal:0
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
        }
    },
    methods: {
        async Guardar()
        {
            this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;
            this.$http.put("productoPresentaciones/"+this.objProductoPresentacion.IdProductoPresentacion,this.objProductoPresentacion
            ).then((res) => {
                this.EjecutaConExito(res);
            }).catch((err) => {
                this.EjecutaConError(err);
            });
        },
        EjecutaConExito(res){
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err){
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        RecuperarPresentacion()
        {
            this.$http.get(
                'productoPresentaciones/'+this.objProductoPresentacion.IdProductoPresentacion
            ).then((res)=>{
                this.objProductoPresentacion = res.data.data;
                this.objProductoPresentacion.SubUnidadCompleta = this.objProductoPresentacion.Cantidad + ' ' + this.objProductoPresentacion.SubUnidad;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
        Limpiar()
        {
            this.objProductoPresentacion={
                IdProductoPresentacion:0,
                Material:'',
                Unidad:'',
                SubUnidad:'',
                Precio:0,
                Cantidad:0,
                PrecioTotal:0
            };
        },
        Calcular(item)
        {
            let Total = (isNaN(item.CantidadProductos)) ? 0 : parseFloat((item.Costo*item.CantidadProductos)/item.Cantidad).toFixed(2);
            this.objProductoPresentacion.PrecioTotal=Total;
        },
    },
    created() {
        this.poBtnSave.Toast = 0;
        this.bus.$off('Recovery_'+this.Emit);

        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
            this.bus.$off('Save_'+this.Emit);

            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });

            this.Limpiar();
            
            if (Id!='') 
            {
                this.objProductoPresentacion.IdProductoPresentacion = Id;
                this.RecuperarPresentacion();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    },
}
</script>